import React, { Suspense } from 'react';
import SkeletonGrid from './SkeletonGrid';

// Lazy load heavy components
export const LazyHashtagPage = React.lazy(() => import('./HashtagPage'));
export const LazyArticlesCarousel = React.lazy(() => import('./ArticlesCaroussel'));

// Wrapper components with suspense
interface LazyWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  darkMode?: boolean;
}

export const LazyWrapper: React.FC<LazyWrapperProps> = ({
  children,
  fallback,
  darkMode = false
}) => (
  <Suspense fallback={fallback || <SkeletonGrid darkMode={darkMode} count={3} />}>
    {children}
  </Suspense>
);

// Specific lazy wrappers for common use cases
export const LazyHashtagPageWrapper: React.FC<React.ComponentProps<typeof LazyHashtagPage>> = (props) => (
  <LazyWrapper darkMode={props.darkMode}>
    <LazyHashtagPage {...props} />
  </LazyWrapper>
);

export const LazyArticlesCarouselWrapper: React.FC = () => (
  <LazyWrapper>
    <LazyArticlesCarousel />
  </LazyWrapper>
);
